import { Component, Input } from '@angular/core';

@Component({
  selector: 'payarc-stat-tile',
  template: `
    <div class="pa-tile" [class.pa-tile--hero]="hero" [style.--pa-accent]="accent || null">
      <span class="pa-tile__label">{{ label }}</span>
      <b class="pa-tile__value">{{ value }}</b>
      <em class="pa-tile__note" *ngIf="note">{{ note }}</em>
    </div>`,
  styleUrls: ['./payarc-stat-tile.component.css'],
  standalone: false
})
export class PayarcStatTileComponent {
  @Input() label = '';
  @Input() value: string | number = '';
  @Input() note?: string;
  @Input() hero = false;
  /** optional accent bar color (defaults to blue-light) */
  @Input() accent?: string;
}
